import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css'; // You'll create this CSS file separately
import footer_logo from '../Components/Images/logo10.png'
import footer_logo1 from '../Components/Images/ab.jpg'

const Footergpt = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Column 1: About Company */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src={footer_logo} alt="zartec Logo" />
            {/* <h5>D-TECT</h5> */}
          </div>
          <p className="company-description">
            Zartec solutions provides innovative anti-theft solutions to protect your merchandise and assets. 
            Our EAS systems offer reliable security with cutting-edge technology.
          </p>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3 style={{fontFamily:"Poppins", fontSize:"15px"}}>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
            
            <li><Link to="/services" onClick={() => window.scrollTo(0, 0)}>Services</Link></li>
            <li><Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
            {/* <li><Link to="/eas-security-products/detacher">Accessories</Link></li>
            <li><Link to="/contact-us">Contact</Link></li> */}
          </ul>
        </div>

        {/* Column 3: Products */}
        <div className="footer-column">
          <h3 style={{fontFamily:"Poppins", fontSize:"15px"}}>Our Solutions</h3>
          <ul className="footer-links">
            <li><Link to="/eas-system" onClick={() => window.scrollTo(0, 0)}>EAS Systems</Link></li>
            <li><Link to="/retail-scales" onClick={() => window.scrollTo(0, 0)}>Weighing Scales</Link></li>
            <li><Link to="/hanshowclaude" onClick={() => window.scrollTo(0, 0)}>Hanshow ESL</Link></li>
            <li><Link to="/continuous-inkjet-printer" onClick={() => window.scrollTo(0, 0)}>CIJ Printers</Link></li>
            <li><Link to="/thermal-inkjet-printer" onClick={() => window.scrollTo(0, 0)}>TIJ Printers</Link></li>
            <li><Link to="/sunmi-pos" onClick={() => window.scrollTo(0, 0)}>Sunmi Devices</Link></li>
          </ul>
        </div>

        {/* Column 4: Contact Information */}
        <div className="footer-column">
          <h3 style={{fontFamily:"Poppins", fontSize:"15px"}}>Contact Us</h3>
          <ul className="contact-info">
            <li>
              <i className="fas fa-map-marker-alt"></i>
              <span>71-75 Shelton Street, Covent Garden,
              London, United Kingdom, WC2H 9JQ</span>
            </li>
            <li>
              <i className="fas fa-phone"></i>
              <span>17795960</span>
            </li>
            <li>
              <i className="fas fa-envelope"></i>
              <span>sales@zartecsolutions.com</span>
            </li>
            <li>
              <i className="fas fa-clock"></i>
              <span>Mon - Fri: 8:00 AM - 6:00 PM</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="copyright-section">
        <p>&copy; {new Date().getFullYear()} Zartec Solutions. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/sitemap">Sitemap</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footergpt;